class BlakoMobileMenu {
  constructor(root) {
    this.root = root;
    this.oneOpen = root.dataset.oneOpen === 'true';
    this.triggers = Array.from(root.querySelectorAll('[data-blako-mm-trigger]'));
    this.triggers.forEach((trigger) => trigger.addEventListener('click', () => this.toggle(trigger)));

    const drawerDetails = root.closest('#Details-menu-drawer-container');
    if (drawerDetails) {
      this.drawerDetails = drawerDetails;
      this.syncDrawerOpenState();
      drawerDetails.addEventListener('toggle', () => {
        this.syncDrawerOpenState();
        if (!drawerDetails.open) this.closeAll();
      });
    }
  }

  syncDrawerOpenState() {
    if (!this.drawerDetails) return;
    document.body.classList.toggle('blako-mobile-menu-open', this.drawerDetails.open);
  }

  toggle(trigger) {
    const item = trigger.closest('[data-blako-mm-accordion]');
    if (!item) return;
    const group = item.parentElement;
    const willOpen = !item.classList.contains('is-open');

    if (willOpen && this.oneOpen && group) {
      Array.from(group.children).forEach((sibling) => {
        if (sibling !== item && sibling.matches('[data-blako-mm-accordion]')) this.setOpen(sibling, false);
      });
    }
    this.setOpen(item, willOpen);
  }

  setOpen(item, open) {
    item.classList.toggle('is-open', open);
    const trigger = item.querySelector(':scope > [data-blako-mm-trigger]');
    const panel = item.querySelector(':scope > .blako-mobile-menu__panel');
    if (trigger) trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (panel) panel.setAttribute('aria-hidden', open ? 'false' : 'true');
  }

  closeAll() {
    this.root.querySelectorAll('[data-blako-mm-accordion].is-open').forEach((item) => this.setOpen(item, false));
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-blako-mobile-menu]').forEach((root) => new BlakoMobileMenu(root));
});
